import { PillStatus } from '@/components/shared/Pill/types';
import { PillMenu } from '@/components/shared/PillMenu';
import { useBulkReviewActionData } from '../../hooks/useBulkReviewActionData';
import { Tooltip } from '@mui/material';

const getPillStatus = (): PillStatus => {
  return 'disabled';
};

export const BulkReviewAction = ({
  variant = 'default',
  poiType,
  className = '',
}: {
  variant: 'default' | 'compact';
  poiType?: string;
  className?: string;
}) => {
  const { allActions, disabled, loading, handleChange } = useBulkReviewActionData({ poiType });
  return (
    <Tooltip
      title={disabled ? 'Select at least one point of interest' : 'Bulk review action'}
      arrow
      placement="left"
    >
      <span>
        <PillMenu
          key={`bulk-review-action`}
          size={variant === 'default' ? 'medium' : 'small'}
          options={allActions}
          initialValue="Action"
          label="Action"
          loading={loading}
          loadingLabel="Updating..."
          onChange={handleChange}
          getPillStatus={getPillStatus}
          disabled={disabled}
          className={className}
        />
      </span>
    </Tooltip>
  );
};
